<template>
    <button
        class="a-button"
        :class="{
            'a-button--processing': processing || isProcessing,
            'a-button--gray': gray,
            'a-button--selected': selected
        }"
        :type="type"
        :disabled="isProcessing"
        @click="handleClick($event)"
    >
        <a-icon
            v-if="icon"
            :icon="icon"
            class="a-button__icon"
        />
        <slot></slot>
        <a-icon
            v-if="processing || isProcessing"
            icon="SpinnerSmall"
            class="a-button__spinner"
        />
    </button>
</template>

<script>
export default {
    data() {
        return {
            processing: false
        }
    },
    props: {
        icon: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'button'
        },
        selected: {
            type: Boolean,
            default: false
        },
        isProcessing: {
            type: Boolean,
            default: false
        },
        // if true then prevent event emitting
        // and show spinner
        processOnClick: {
            type: Boolean,
            default: false
        },
        gray: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick($event) {
            if(!this.processing) {
                this.$emit('click', $event)
            }
            if(this.processOnClick) {
                this.processing = true
            }
        }
    }
}
</script>
